import { getDefaultRefreshFilter } from 'common/features/Filters/predefined/Refresh/refresh.defaults';
import { NearbyGalleriesFiltersState } from './filter.types';

export const getDefaultFilters = (): NearbyGalleriesFiltersState => ({
  sort: 'byTitle',
  ...getDefaultRefreshFilter(),
});

export const filterInitialState: NearbyGalleriesFiltersState = getDefaultFilters();
